/* VOLVER ARRIBA · 27-ago-2026
 *
 * 🔴 NO USA IntersectionObserver. Aquí no hay ningún elemento cuya entrada o
 * salida marque el momento: el disparador es una DISTANCIA (dos pantallas), y
 * para una distancia lo que corresponde es leer el scroll. Un centinela invisible
 * plantado a 2×altura sería un nodo inventado para simular una resta.
 *
 * 🔴 EL SCROLL SE LEE EN rAF, NO EN CADA EVENTO. `scroll` dispara decenas de
 * veces por gesto; leer `scrollY` en cada uno obliga al navegador a recalcular el
 * diseño dentro del gesto. Con el candado de cuadro se lee una vez por cuadro.
 * El oyente va `passive`: sin eso el navegador tiene que esperar a ver si alguien
 * cancela el gesto, y el scroll se sale del camino rápido.
 *
 * 🔴 FAIL-VISIBLE. El botón nace `hidden` en el HTML. Si este archivo no carga,
 * no queda una flecha muerta flotando en la esquina: no existe.
 */
(function () {
  var boton = document.querySelector('[data-arriba]');
  if (!boton) return;

  /* Dos pantallas. Menos y aparece en páginas donde no hace falta; más y en un
     celular chico llega tarde. Se recalcula al girar el teléfono. */
  function umbral() { return window.innerHeight * 2; }

  var pedido = false;
  var visible = false;

  function revisar() {
    pedido = false;
    var debe = (window.scrollY || document.documentElement.scrollTop || 0) > umbral();
    if (debe === visible) return;   /* nada que tocar: no se ensucia el DOM */
    visible = debe;
    if (debe) boton.removeAttribute('hidden');
    else boton.setAttribute('hidden', '');
  }

  function alRodar() {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(revisar);
  }

  addEventListener('scroll', alRodar, { passive: true });
  addEventListener('resize', alRodar);
  revisar();

  /* ── PUBLICAR EL ALTO REAL DE LA CABECERA ────────────────────────────────
     🔴 EL NÚMERO ESCRITO A MANO NO SIRVE: CAMBIA CON EL ANCHO. Medido el 27-ago:
     `.a-cima` mide 128px a 1280 y 149 a 390 —el aviso se parte en dos renglones—.
     La bolsa vacía resta ese alto para ocupar exactamente una pantalla; con el
     respaldo de 128 en celular se pasaba 21px y asomaba una franja del pie negro
     bajo el pliegue. Justo lo que esa pantalla completa venía a arreglar.

     Vive aquí porque este archivo lo carga el PIE, y el pie está en todas las
     páginas: así el dato existe en cualquier plantilla que lo necesite, hoy la
     bolsa y mañana la que sea. Se recalcula al girar el teléfono y cuando el
     aviso cambia de alto. */
  var cima = document.querySelector('.a-cima');
  if (cima) {
    var medirCima = function () {
      var alto = Math.round(cima.getBoundingClientRect().height);
      if (alto > 0) document.documentElement.style.setProperty('--alto-cima', alto + 'px');
    };
    medirCima();
    addEventListener('resize', medirCima);
    if (window.ResizeObserver) new ResizeObserver(medirCima).observe(cima);
  }

  /* ── APARTARSE DE LA BARRA DE COMPRA ─────────────────────────────────────
     El CSS ya sube el botón cuando la barra está visible, pero necesita saber
     CUÁNTO. La altura se mide sobre la barra real en vez de dejarla escrita a
     mano: el nombre de la prenda puede partirse en dos renglones y el número
     fijo dejaría el círculo montado encima. Si no hay barra —cualquier página
     que no sea una ficha— no se escribe nada y manda el valor de respaldo. */
  var barra = document.querySelector('.f-barra');
  if (barra) {
    var medirBarra = function () {
      var alto = Math.round(barra.getBoundingClientRect().height);
      if (alto > 0) document.documentElement.style.setProperty('--alto-barra', alto + 'px');
    };
    medirBarra();
    addEventListener('resize', medirBarra);
    if (window.ResizeObserver) new ResizeObserver(medirBarra).observe(barra);
  }

  boton.addEventListener('click', function () {
    /* `prefers-reduced-motion` se respeta a mano. `scroll-behavior: smooth` en
       CSS lo respeta solo; `scrollTo({behavior:'smooth'})` NO — pasa por encima
       de la preferencia del sistema. Doce mil píxeles de deslizamiento a quien
       pidió que nada se mueva es exactamente lo que esa preferencia evita. */
    var quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: quieto ? 'auto' : 'smooth' });

    /* 🔴 Y EL FOCO SE VA CON LA VISTA. Subir la página sin mover el foco deja a
       quien navega con teclado al final del documento: el siguiente tabulador lo
       devuelve al pie que acaba de abandonar. `preventScroll` evita que el foco
       pelee con el deslizamiento que acabamos de lanzar. */
    var meta = document.getElementById('contenido') || document.querySelector('h1');
    if (meta) {
      if (!meta.hasAttribute('tabindex')) meta.setAttribute('tabindex', '-1');
      meta.focus({ preventScroll: true });
    }
  });
})();
